import { defineMessage } from 'services/localization';

export const messages = {
    addPayer: defineMessage('add_a_payer'),
    bubbleText: defineMessage('send_payment'),
    payerTag: defineMessage('can_send_payment_with_any_bank_account'),
    stepDescription: defineMessage('payers_can_authorize_th_payments_for_processing'),
};
